import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import {pollsEdit_template} from "../components/templates/pollsEdit_template";

declare var ko: any;
declare var page: any;

export class polls_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected pollsEdit: pollsEdit_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(){

        return "polls_edit";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.pollsEdit = new pollsEdit_template("editForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Edit Poll");

        return [this.pollsEdit.build()];
    }

    public fillPage() : void{

        this.pollsEdit.buildDatePickerCalendar();
        this.getData();
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.pollsEdit.getTemplateViewModel();

        //delete templateViewModel.Job;

        return templateViewModel;
    }

    protected getData(){

        let id: number;

        if ((id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.pollsEdit.getTemplateViewModel().id(id);
        }

        this.loadingIn(this.pollsEdit.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/polls/get/' + id;
        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", ko.toJSON(this.pollsEdit.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.data);
                obj.loadingOut(obj.pollsEdit.builtTemplate);
            });
        }
    }

    protected updateList(data){

        this.pollsEdit.setId(data.id);
        this.pollsEdit.setName(data.name);
        this.pollsEdit.setDescription(data.description);
        this.pollsEdit.setType(data.type);
        this.pollsEdit.setChoices(data.choices ? data.choices : []);
        if (data.discussionArticle) {
            this.pollsEdit.setDiscussionArticle(data.discussionArticle);
        }
        //This needs to refer to the data like an array to use the close date, otherwise it won't work.
        this.pollsEdit.setDateClosed(data['dateClosed'] ? data['dateClosed'] : null);
    }

    protected savePoll() {

        this.loadingIn(this.pollsEdit.builtTemplate);

        let formReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/polls/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.pollsEdit.getViewModelForRequest()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Polls saved successfully !");
                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/config/polls/');
                });
                obj.loadingOut(obj.pollsEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected getArticlesSuggestion(keyword) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/articles/next/get/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.articles) {
                    obj.pollsEdit.setArticlesFilter(responseParsed.data.articles);
                }

            });

            //obj.editForm.deactivateLoading();
        }
    }

    public cancelForm() {
        this.cancel(this.getVnAppZone().app.params.id);
    }

    protected cancel(id) {
        //release lock
        this.releaseLock(id);
        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/polls/');
    }

    protected releaseLock(id) {
        // request a lock release
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/polls/release/' + id;
        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", this.pollsEdit.getTemplateViewModel().id()]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

}


// WEBPACK FOOTER //
// ./js/modules/polls_edit.ts